import { render, staticRenderFns } from "./TransferLever.vue?vue&type=template&id=882a8f18"
import script from "./TransferLever.vue?vue&type=script&lang=js"
export * from "./TransferLever.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports